module.exports = __webpack_public_path__ + "img/a-3.8c89bf49.jpg";